import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full min-h-screen bg-background-50 flex flex-col">
      <title>页面不存在 - 奥田咲影迷门户</title>
      <meta name="robots" content="noindex" />

      <SiteHeader />

      <main className="flex-1 w-full px-4 md:px-8 pt-28 md:pt-36 pb-20 flex items-center">
        <div className="w-full max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-background-100 text-primary-400">
            <i className="ri-compass-3-line text-4xl"></i>
          </span>
          <p className="mt-6 font-heading text-6xl md:text-8xl font-bold text-background-300">404</p>
          <h1 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            页面不存在或已被移除
          </h1>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-8 max-w-xl mx-auto">
            你访问的地址可能输入有误，或者该页面已经调整。可以返回首页，
            或者直接前往影视作品、最新动态栏目继续浏览。
          </p>
          <p className="mt-2 text-xs text-foreground-400 font-mono break-all">{location.pathname}</p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/works"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              <i className="ri-film-line"></i>
              影视作品
            </Link>
            <Link
              to="/news"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              <i className="ri-newspaper-line"></i>
              最新动态
            </Link>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}